import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Category } from "@types";
import { App } from "antd";
import { useTranslation } from "react-i18next";

export const useAddCategory = () => {
    const axios = useAxios();
    const queryClient = useQueryClient();
    const {t} = useTranslation();
    const {message} = App.useApp();

    const addCategory = async (category: Category) => {
        try {
            const response = await axios.post("/api/categories", category);
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.addCategory"));
        }
    }

    return useMutation({mutationFn: addCategory, 
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["categories"]});
            message.success(t("messages.success.addCategory"));
        }
    });
}
